/**
 * @module components\TechnologyDetails
 */
import Vue from "vue";
import Component from "vue-class-component";
import { globalMutations } from "@/store";
import store from "@/store";

@Component
export default class TechnologyDetails extends Vue {
  insurance = true;
  recharges = false;
  gold = false;
  biometricdevices = false;
  mpos = false;

  closeModal() {
    store.commit(globalMutations.detailModal);
  }
}
